import { useState } from "react";

export default function AddToTradeIconButton({
  cardName,
  disabled = false,
  disabledReason = "",
  busy = false,
  onClick,
}) {
  const [isHovered, setIsHovered] = useState(false);
  const isUnavailable = disabled || typeof onClick !== "function";
  const title = isUnavailable
    ? (disabledReason || "Unavailable")
    : (busy ? "Adding..." : "Add to trade");

  return (
    <button
      type="button"
      aria-label={isUnavailable ? (disabledReason || "Card unavailable for trade") : `Add ${cardName || "card"} to trade`}
      title={title}
      disabled={isUnavailable}
      onMouseEnter={() => {
        if (!isUnavailable) {
          setIsHovered(true);
        }
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
      onClick={(event) => {
        event.stopPropagation();

        if (!isUnavailable) {
          onClick();
        }
      }}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "26px",
        height: "26px",
        padding: 0,
        borderRadius: "8px",
        border: `1px solid ${isUnavailable ? "#cbd5e1" : "#0f766e"}`,
        background: isUnavailable ? "#f8fafc" : (isHovered ? "#14b8a6" : "#0f766e"),
        color: isUnavailable ? "#94a3b8" : "#ffffff",
        cursor: isUnavailable ? "not-allowed" : "pointer",
        boxShadow: isUnavailable ? "none" : (isHovered ? "0 8px 18px rgba(20, 184, 166, 0.24)" : "0 4px 12px rgba(15, 23, 42, 0.08)"),
        transition: "background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
        opacity: isUnavailable && !disabled ? 0.7 : 1
      }}
    >
      <span
        aria-hidden="true"
        style={{
          display: "inline-grid",
          placeItems: "center",
          width: "100%",
          height: "100%",
          lineHeight: 0
        }}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6 2.25V9.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          <path d="M2.25 6H9.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </span>
    </button>
  );
}